/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Remove_List_LabelInputs */

const en_markers_remove_list_label = /** @type {(inputs: Markers_Remove_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove Marker List`)
};

const fr_markers_remove_list_label = /** @type {(inputs: Markers_Remove_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer la liste de marqueurs`)
};

const de_markers_remove_list_label = /** @type {(inputs: Markers_Remove_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markerliste entfernen`)
};

const it_markers_remove_list_label = /** @type {(inputs: Markers_Remove_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi elenco marcatori`)
};

const ru_markers_remove_list_label = /** @type {(inputs: Markers_Remove_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить список маркеров`)
};

const es_markers_remove_list_label = /** @type {(inputs: Markers_Remove_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar lista de marcadores`)
};

const zh_cn2_markers_remove_list_label = /** @type {(inputs: Markers_Remove_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除标记列表`)
};

const ja_markers_remove_list_label = /** @type {(inputs: Markers_Remove_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マーカーリストを削除`)
};

const hi_markers_remove_list_label = /** @type {(inputs: Markers_Remove_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मार्कर सूची हटाएं`)
};

const pt_pt2_markers_remove_list_label = /** @type {(inputs: Markers_Remove_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover lista de marcadores`)
};

/**
* | output |
* | --- |
* | "Remove Marker List" |
*
* @param {Markers_Remove_List_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_remove_list_label = /** @type {((inputs?: Markers_Remove_List_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Remove_List_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_remove_list_label(inputs)
	if (locale === "de") return de_markers_remove_list_label(inputs)
	if (locale === "it") return it_markers_remove_list_label(inputs)
	if (locale === "ru") return ru_markers_remove_list_label(inputs)
	if (locale === "es") return es_markers_remove_list_label(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_remove_list_label(inputs)
	if (locale === "ja") return ja_markers_remove_list_label(inputs)
	if (locale === "hi") return hi_markers_remove_list_label(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_remove_list_label(inputs)
	return en_markers_remove_list_label(inputs)
});